import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        list: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('consignments', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        show: (cntx, { id }) => {
            axios.get(`consignments/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        },
        create: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('consignments', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        imports: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.post('imports', params)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        update: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.put(`consignments/${params.id}`, params.data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        remove: (cntx, id) => {
            return new Promise((resolve, reject) => {
                axios.delete(`consignments/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        cartons: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('cartons', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        seasons: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('seasons', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        files: (cntx, params) => {
            return new Promise((resolve, reject) => {
                axios.get('files', { params: params })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}